import React, { Component } from "react";
import SkillCard from "./SkillCard";
import skills from "./myskills";
import AOS from "aos";

class Skills extends Component {
  componentDidMount() {
    AOS.init({ duration: 2000 });
  }

  render() {
    return (
      <div className="skills-section">
        <div
          data-aos="fade-up"
          data-aos-anchor=".education-section"
          data-aos-anchor-placement="bottom-center"
          className="heading"
        >
          Skills
        </div>
        {skills.map((skill, idx) => {
          let color = "white";
          if (idx % 2 == 0) {
            color = "#d4d9e5";
          }
          return (
            <SkillCard
              name={skill.name}
              img={skill.img}
              percent={skill.percent}
              col={color}
            />
          );
        })}
      </div>
    );
  }
}

export default Skills;
